import React, { useEffect, useRef, useState } from 'react';
import ReactGA from 'react-ga4';
import './Home8.scss'

const Home8 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    const videoRef = useRef(null); // Referencia al video
    const [isVisible, setIsVisible] = useState(false); // Estado de visibilidad
    const [isMuted, setIsMuted] = useState(true);
    const [isVideo, setIsVideo] = useState(true);
    const [outVideo, setOutVideo] = useState(false);

    const mx = "eight-body-section fade-slide-in-animation-8 disposition-column justify-between align-center ";

    const scroll = () =>{
        return sectionCurrently === Section.Section8 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }

    const handleRedirect = () => {
        const url = 'https://app.conkarta.com/application';
        window.open(url, '_blank');

        try {
            ReactGA.event({
                category: 'Botón',
                action: 'Clic en botón',
                label: 'Botón Sección "Video"',
            });
        } catch (error) {
            console.error('Error al enviar el evento a GA:', error);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
            setIsVisible(entry.isIntersecting);
        },
        { threshold: 0.5 }
        );
    
        if (videoRef.current) {
            observer.observe(videoRef.current); 
        }
    
        return () => {
            if (videoRef.current) {
                observer.unobserve(videoRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            if (videoRef.current && videoRef.current.paused) {
                setTimeout(() => {
                    if (videoRef.current) {
                        videoRef.current.play().catch((err) => console.log(err));
                    }
                }, 1500);
            }
        } else {
            if (videoRef.current && !videoRef.current.paused) {
                videoRef.current.pause();
            }
        }
    }, [isVisible]);

    const playVideo = () => {
        setOutVideo(false);
        setIsVideo(true);
        if (videoRef.current && videoRef.current.paused) {
            videoRef.current.play().catch((err) => console.log(err));
        }
    }

    const finishVideo = () =>{
        setIsVideo(false)
        setOutVideo(true);
    }
    return (
        <>
            <div className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
                <div className = "disposition-column justify-start align-center">
                    {   
                        isVideo &&
                        <video  ref={videoRef}
                                src="assets/Home/Home8/Karta-CreditCard-FallingMetallic.mp4" 
                                className = { `${"video-card-img "} ${outVideo ? "fade-out-animation" : ""}`} 
                                muted={isMuted} 
                                autoPlay 
                                playsInline 
                                onEnded={() => finishVideo()}
                        />
                    }
                    {   
                        !isVideo &&
                        <img src="assets/Home/Home8/card-img.png" className = "video-card-img fade-in-animation-8" alt = "Credit-Card"/>
                    }
                    <div className = "buttons-space disposition-row justify-between align-center">
                        <img src = "assets/Home/Home8/actualizar.png" className = "video-icon" alt = "Update" onClick={() => playVideo()}></img>
                        {
                            isMuted &&
                            <img src = "assets/Home/Home8/silencio.png" className = "video-icon" alt = "Sound" onClick={() => setIsMuted(false)}></img>
                        }
                        {
                            !isMuted &&
                            <img src = "assets/Home/Home8/volumen.png" className = "video-icon" alt = "Muted" onClick={() => setIsMuted(true)}></img>
                        }
                    </div>
                </div>
                <div className = "disposition-column justify-start align-center">
                    <button className = "join-button"  onClick={() => handleRedirect()}>Apply now</button>
                    <p className = "text-2">$300 Annual Fee</p>
                </div>
            </div>
        </>
    );
};

export default Home8;
